import { createPortal } from "react-dom";
import { useMap } from "react-leaflet";
import { useDispatch } from "react-redux";
import { setModal } from "../../store/reducers/helpersReducer";
import { Dialog } from "@mui/material";
import TasksView from "../contents/TasksViewNew";

const ModalTasks = (props) => {
    const map = useMap();
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(setModal(null));
    };

    return (
        // createPortal(

        <TasksView
            isModal={true}
            onClose={handleClose}
            map={map}
            fromStartPage={false}
        />
        // ,
        //     document.body
        // )
    );
};

export default ModalTasks;
